import {
  DisplayNotesSettings,
  PartItemSettings,
  ShoppingCartSettings
} from 'services/userPreferences/types';

export enum VIEWS {
  COMPACT = 'C',
  STANDARD = 'S'
}

export enum AVAILABILITY {
  BY_DATE = 'D',
  BY_SOURCE = 'S'
}

export const GA_CART_SETTINGS_FORM = {
  formLocation: 'PCC Shopping cart Page',
  formName: 'shopping cart settings drawer',
  formSuccess: 'success',
  formFailure: 'fail',
  formFieldCausingError: 'api failed',
  compact: 'Compact',
  standard: 'Standard',
  viewByDate: 'view by date',
  viewBySource: 'view by source',
  yes: 'y',
  no: 'n'
};

const PART_OR_ITEMS_TOGGLES_DEFAULT: PartItemSettings = {
  showItemRowNumber: false,
  expandAdditionalInfo: false,
  displayImages: true
};
const DISPLAY_NOTES_TOGGLES_DEFAULT: DisplayNotesSettings = {
  showEquipmentNumber: false,
  showLineItemNote: false,
  showCustomerPartNumber: false,
  showCustomerItemNumber: false
};
const DISPLAY_NOTES_TOGGLES_DEFAULT_DEALER_AND_CSP: DisplayNotesSettings = {
  showEquipmentNumber: true,
  showLineItemNote: true,
  showCustomerPartNumber: true,
  showCustomerItemNumber: true
};

export const DEFAULT_CART_SETTINGS: ShoppingCartSettings = {
  pageView: VIEWS.STANDARD,
  showAvailability: AVAILABILITY.BY_DATE,
  standardShowAvailability: AVAILABILITY.BY_DATE,
  showFulfillment: 'P',
  partOrItem: PART_OR_ITEMS_TOGGLES_DEFAULT,
  displayNotes: DISPLAY_NOTES_TOGGLES_DEFAULT,
  isUserSettings: false
};

export const DEFAULT_CART_SETTINGS_DEALER_AND_CSP: ShoppingCartSettings = {
  pageView: VIEWS.STANDARD,
  showAvailability: AVAILABILITY.BY_SOURCE,
  compactShowAvailability: AVAILABILITY.BY_SOURCE,
  showFulfillment: 'P',
  partOrItem: { ...PART_OR_ITEMS_TOGGLES_DEFAULT, showItemRowNumber: true },
  displayNotes: DISPLAY_NOTES_TOGGLES_DEFAULT_DEALER_AND_CSP,
  isUserSettings: false
};
